import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";
import { AdminProductsService } from "../../../pages/admin-pages/products/services/admin-products.service";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { FailState } from "../../models/fail-state";
import { ProductStandardListsState } from "../../models/mp-admin/product-standard-lists-state";
import { AppState } from "../../reducers";
import { AdminProductsSelectors } from "../../selectors/admin-products.selectors";

@Injectable()
export class ProductStandardListsEffects {
	productStandardLists = createEffect(() =>
		this.actions.pipe(
			ofType(AdminProductsActions.productStandardLists.get),
			withLatestFrom(this.store.select(AdminProductsSelectors.productStandardLists)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(AdminProductsActions.productStandardLists.getSuccess({ state }))
					: of(AdminProductsActions.productStandardLists.getApi())
			)
		)
	);

	productStandardListsApi = createEffect(() =>
		this.actions.pipe(
			ofType(AdminProductsActions.productStandardLists.getApi),
			switchMap(() =>
				this.service.getProductStandardLists().pipe(
					map((standardLists) =>
						AdminProductsActions.productStandardLists.getSuccess({
							state: { standardLists, loading: false, hasLoaded: true }
						})
					),
					catchError((error) =>
						of(AdminProductsActions.productStandardLists.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private service: AdminProductsService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: ProductStandardListsState): boolean {
		return (
			state !== undefined &&
			!_.has(state, "error") &&
			!state.loading &&
			state.hasLoaded === true &&
			_.has(state, "standardLists") &&
			state.standardLists !== undefined
		);
	}
}
